import styled from '@emotion/styled';
import { css } from '@emotion/react';

type StyledTabProps = {
    isSelected: boolean;
};

const StyledTab = styled('button')<StyledTabProps>(({ theme, isSelected }) => {
    return css`
        background: transparent;
        border: none;
        padding: ${theme.spacing['spacing-2']};
        font-family: inherit;
        font-size: ${theme.fontSizes[2]};
        color: ${theme.colors['neutral-5']};
        cursor: pointer;

        &:focus {
            outline: none;
            box-shadow: inset ${theme.focusRing};
        }

        ${isSelected &&
        `
            border-bottom: 3px solid ${theme.colors['primary-brand']};
            color: ${theme.buttons.tertiary.hoverColor};
        `};
    `;
});

type StyledTabsProps = {
    isFullWidth: boolean;
};

const StyledTabs = styled('div')<StyledTabsProps>(({ theme, isFullWidth }) => {
    return css`
        display: ${isFullWidth ? 'flex' : 'block'};
        border-bottom: 1px solid ${theme.colors['graphic-divider']};

        ${isFullWidth &&
        `
            ${StyledTab} {
                flex-grow: 1;
            }
        `};
    `;
});

const StyledTabPanel = styled('div')(({ theme }) => {
    return css`
        padding-top: ${theme.spacing['spacing-3']};
    `;
});

export { StyledTab, StyledTabs, StyledTabPanel };
